// Campus photo for /colleges/university-of-alabama-at-birmingham: Public domain, by University of Alabama at Birmingham, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AUAB_Campus_Green_Bird's-Eye_View.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/university-of-alabama-at-birmingham/; credited under the photo.
const photo = {
    "slug": "university-of-alabama-at-birmingham",
    "alt": "An aerial view of the Campus Green with its crossing walkways and surrounding buildings at the University of Alabama at Birmingham, with downtown Birmingham behind",
    "src": "/colleges/university-of-alabama-at-birmingham/campus-1600.webp",
    "srcSmall": "/colleges/university-of-alabama-at-birmingham/campus-800.webp",
    "srcMid": "/colleges/university-of-alabama-at-birmingham/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/university-of-alabama-at-birmingham/og.jpg",
    "title": "UAB Campus Green Bird's-Eye View",
    "author": "University of Alabama at Birmingham",
    "license": "Public domain",
    "licenseUrl": null,
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AUAB_Campus_Green_Bird's-Eye_View.jpg",
    "read": "2026-10-01"
};

export default photo;
